import * as React from 'react';
import OutputSelectContainer from '../../containers/output-select';
import {
	Dialog, DialogType,
	MessageBar, MessageBarType,
	Overlay, Spinner, SpinnerType
} from 'office-ui-fabric-react';

interface IProps {
	title: string;
	isOpen: boolean;
	type?: DialogType;
	isBlocking?: boolean;
	errorMessages: string[];
	warningMessages: string[];
	overlayMessage?: string;
	onDismiss?: () => void;
	dismissErrorMessage: () => void;

}

export class Cascade extends React.Component<IProps, any> {

	timerId: number;

	constructor(props: any) {
		super(props);
	}

	private startTimer = () => {
		return this.timerId = setInterval(moveTinyMceDialogInsideModal, 100);
	}

	private stopTimer = () => {
		return clearInterval(this.timerId);
	}

	public componentDidUpdate = (prevProps) => {

		let { isOpen } = this.props;
		let wasOpen = prevProps.isOpen;
		let stillOpen = wasOpen === isOpen;
		if (!stillOpen) {
			if (isOpen) {
				this.startTimer();
			}
			else {
				this.stopTimer();
			}
		}
	}

	public render() {

		let { title, isOpen, type, isBlocking, errorMessages, warningMessages, onDismiss, dismissErrorMessage, children, overlayMessage } = this.props;

		let errorItems: JSX.Element[] = errorMessages.map((v, i) => {
			return <li key={'modal-error-message_' + i}>{v}</li>;
		});

		let warningItems: JSX.Element[] = warningMessages.map((v, i) => {
			return <li key={'modal-warning-message_' + i}>{v}</li>;
		});

		return (
			<div className={"cascade"}>
				{/* <Dialog 
					isOpen={ isOpen }
					type={ type == null ? DialogType.largeHeader : type }
					onDismiss={ onDismiss }
					title={ title } 
					isBlocking={ isBlocking }
					containerClassName="control-dialog"
					
					// Allow elements that are outside the focus trap to be focusable.
					// This is needed to allow inputs in TinyMCE dialogs to be focused,
					// since these items aren't children of the dialog, they're appended
					// to the body directly.
					forceFocusInsideTrap={false}
					isClickableOutsideFocusTrap={true}> */}
				{
					overlayMessage ?
						<Overlay className="modal-loading-overlay" isDarkThemed={true}>
							<Spinner type={SpinnerType.normal} label={overlayMessage} />
						</Overlay> : null
				}
				{
					errorItems.length || warningItems.length ?
						(
							<MessageBar
								messageBarType={(errorItems && errorItems.length ? MessageBarType.error : null) ||
									(warningItems && warningItems.length ? MessageBarType.warning : null)}
								onDismiss={dismissErrorMessage} >
								<ul className='modal-error-messages'>{errorItems && errorItems.length ? errorItems : warningItems}</ul>
							</MessageBar>
						)
						: null
				}
				{children}

				<OutputSelectContainer />

				{/* </Dialog> */}
			</div >
		);

	}

}

function moveTinyMceDialogInsideModal() {

	let dialog: Element = document.querySelector('body > [role=dialog].mce-window');
	if (dialog) {
		let container: Element = document.querySelector('.ms-Dialog-main');
		if (container) {
			container.appendChild(dialog);
		}
	}
}


// WEBPACK FOOTER //
// ./source/ts/components/layout/cascade.tsx